import {
  UPDATE_CONFIG,
  UPDATE_NOW_TIME,
  UPDATE_MY_DETAIL,
  UPDATE_MY_INFO,
  // SHOW_NAV,
  // HIDE_NAV,
  SET_NAV,
  UPDATE_MY_DK_GAMES,
  UPDATE_MY_DK_CUP_LAYERS,
  UPDATE_ADDRESS_LIST,
  UPDATE_MY_ADDRESS,
  UPDATE_MY_OPEN_INFO,
  UPDATE_OAUTH_ADDRESS
} from "../mutation-types";
import {
  isNumber,
  getServerTime,
  array2map,
  isArray,
  forEach
} from "../../common/utils";

export default {
  // 底导航切换
  [SET_NAV](state, tabIndex) {
    tabIndex = isNumber(tabIndex) ? tabIndex : -1
    // console.log(tabIndex);
    state.idxTabbar = tabIndex
    state.hasTabbar = tabIndex >= 0 // < 0 不显示
  },
  // [SHOW_NAV](state) {
  //   state.idxTabbar = true
  // },
  // [HIDE_NAV](state) {
  //   state.idxTabbar = true
  // },

  //更新用户基本信息
  [UPDATE_MY_INFO](state, info) {
    let {
      uid
    } = info
    uid = uid > 0 ? +uid : 0
    state.myUid = uid
    state.myInfo = uid > 0 ? { ...info
    } : null
  },

  //更新基本配置
  [UPDATE_CONFIG](state, {
    configInfo,
    cupList,
    cupMap,
    blockMap,
    timeMap
  }) {
    // console.log(blockMap);
    if (configInfo) {
      state.configInfo = configInfo
      state._cupMap = cupMap
      state.timeMap = timeMap
      state.blockMap = blockMap
      state.cupList = cupList
    } else {
      state.configInfo = null
      state._cupMap = null
      state.timeMap = null
      state.blockMap = null
      state.cupList = null
    }
  },


  // 更新当前时间
  [UPDATE_NOW_TIME](state) {
    state._nowTime = getServerTime()
  },

  // 更新我的进展
  [UPDATE_MY_DETAIL](state, {
    info,
    awardList
  }) {

    if (info) {
      state.myDetail = info
    } else {
      state.myDetail = null
    }

    // 我的奖品
    if (awardList && awardList.length > 0) {
      state.myAwards = awardList
    } else {
      state.myAwards = null
    }
  },

  [UPDATE_MY_ADDRESS](state, rewardUserInfo) {
    // 收货人地址相关信息
    if (rewardUserInfo) {
      state.myAddress = rewardUserInfo // {id, cId, name, mobile, address, status}
    } else {
      state.myAddress = null
    }
  },

  [UPDATE_MY_OPEN_INFO](state, {openId, openNick}) {
    state.myOpenId = openId ? openId : ''
    state.myOpenNick = openNick ? openNick : ''
  },


  [UPDATE_MY_DK_GAMES](state, {
    cupId,
    list
  }) {
    if (cupId > 0) {
      const _myDkGames = state._myDkGames || {}
      _myDkGames[cupId] = list
      state._myDkGames = _myDkGames
    }
  },
  [UPDATE_MY_DK_CUP_LAYERS](state, list) {
    if (list && list.length > 0) {
      state._myDkCupPlayers = array2map(list, 'cupId')
    } else {
      state._myDkCupPlayers = null
    }
  },

  [UPDATE_ADDRESS_LIST](state, {
    list
  }) {
    if (isArray(list)) {
      const _addressMap = state._addressMap || {},
        _addressTree = {}

      forEach(list, o => {
        const {
          id,
          pid
        } = o
        const P = _addressTree[pid] || []
        P.push(id)
        _addressTree[pid] = P
        _addressMap[id] = o
      })
      state._addressMap = _addressMap
      state._addressTree = _addressTree
      // console.log(JSON.stringify(_addressTree, null, 2));
    }
  },

  [UPDATE_OAUTH_ADDRESS](state, address) {
    state.oauthAddress = address ? address : null
  }
}
